<template>
  <div class="container" id="forgot-password">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <form v-on:submit.prevent="onSubmit">
          <h2>Yarlow Forgot Password</h2>
          <div class="form-group">
            <label for="forgotPasswordLoginEmail">Email address</label>
            <input v-model="email"
                   type="email"
                   class="form-control"
                   placeholder="Enter email">
          </div>
          <button type="submit" class="btn btn-primary">Submit</button>
        </form>
      </div>
    </div>
    <div>
      <b-modal ref="confirmationModal" @ok="submitConfirmationCode" v-bind:title="title">
        <input v-model="confirmationCode"
               class="form-control needs-padding"
               placeholder="Enter Confirmation Code...">
        <input v-model="newPassword"
               type="password"
               class="form-control"
               id="newPassword"
               placeholder="New Password">
      </b-modal>
    </div>
    <div class="row">
      <div class="col-md-6 offset-md-3 alert-wrapper">
        <b-alert variant="success"
                 dismissible
                 :show="showDismissibleAlert"
                 @dismissed="showDismissibleAlert=false">
          Password Changed. You can now log in with your new password.
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import HomAptCognito from '../../store/lib/cognitoLogin.js'

export default {
  data () {
    return {
      email: null,
      confirmationCode: null,
      newPassword: null,
      showDismissibleAlert: true
    }
  },
  computed: {
    title () {
      return 'Confirmation Sent to: ' + this.email
    }
  },
  methods: {
    async onSubmit () {
      try {
        await HomAptCognito.initiateForgotPasswordCognito(this.email)
        this.showModal()
      } catch (error) {
        console.log(error)
        alert(error.message)
      }
    },
    showModal () {
      this.$refs.confirmationModal.show()
    },
    async submitConfirmationCode () {
      try {
        var result = await HomAptCognito.concludeForgotPassword(this.email, this.confirmationCode, this.newPassword)
        console.log(result)
        this.showDismissibleAlert = true
      } catch (error) {
        alert(error.message)
      }
    }
  }
}
</script>

<style>
#forgot-password {
  padding-top: 14rem;
}

.needs-padding {
  margin-bottom: .5rem;
}

.alert-wrapper {
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/TheForgotPassword.vue